import { TFooterProps } from "@/app/actions/get-home";
import Image from "next/image";
import Link from "next/link";

type TStoreButtonsProps = {
  data: TFooterProps["lojas"];
};

export function StoreButtons({ data }: TStoreButtonsProps) {
  return (
    <div className="flex xl:flex-row flex-col justify-center items-center xl:items-center gap-4">
      <span className="mb-0 text-xs">Baixe o app do TCU</span>
      <div className="flex gap-4">
        {data?.map((item) => (
          <Link key={item.titulo} href={item.url || ""}>
            <Image
              src={item?.imagem || ""}
              width={100}
              height={100}
              alt="Apple Store"
              className="relative hover:drop-shadow-2xl w-[140px] scale-100 hover:scale-105 transition-all duration-300"
            />
          </Link>
        ))}
      </div>
    </div>
  );
}
